// extracted by mini-css-extract-plugin
export default {"body":"ProductPage_body__6V2ec","imageSlider":"ProductPage_imageSlider__MTgio","productInfo":"ProductPage_productInfo__S4t2Q"};